export enum JOURNEY_TYPES {
  IVF = 'IVF',
  TIMED_INTERCOURSE = 'TIMED INTERCOURSE',
  MOCK_CYCLE = 'MOCK CYCLE',
  IUI = 'IUI',
  EMBRYO_TRANSFER = 'EMBRYO TRANSFER',
  VIRTUAL_FIRST_WORKUP = 'VIRTUAL_FIRST_WORKUP'
}
